module.exports = __webpack_public_path__ + "static/media/Pic-0523.e2264000.jpg";